module.exports = __webpack_public_path__ + "img/sol_cap4.2802e3c4.png";